// menu-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuStateService {
  private menuCollapsedSubject = new BehaviorSubject<boolean>(false);
  collapsedState$ = this.menuCollapsedSubject.asObservable();

  toggleCollapsed() {
    const current = this.menuCollapsedSubject.getValue();
    this.menuCollapsedSubject.next(!current);
  }

  setCollapsed(value: boolean) {
    this.menuCollapsedSubject.next(value);
  }

  getCollapsed(): boolean {
    return this.menuCollapsedSubject.getValue();
  }
}
